import { z } from 'zod'
import { Name } from '../../_kernel/Name'
import { Slug } from '../../_kernel/Slug'
import { PropertyFilter } from './PropertyFilter'

export const CANCELLABLE = 'cancellable' as const
export const NON_CANCELLABLE = 'non-cancellable' as const

export const CANCELLATION_POLICIES = [CANCELLABLE, NON_CANCELLABLE] as const

export type CancellationPolicyType = (typeof CANCELLATION_POLICIES)[number]

export const CancellationPolicyValidation = z.object({
  name: z.instanceof(Name, { message: '[CancellationPolicy] name is required' }),
  slug: z.instanceof(Slug, { message: '[CancellationPolicy] slug is required' }),
})

export class CancellationPolicy extends PropertyFilter {
  static create({ name, slug }: z.infer<typeof CancellationPolicyValidation>) {
    CancellationPolicyValidation.parse({ name, slug })
    return new CancellationPolicy(name, slug)
  }
}
